<template>
    <Form
        :errors="errors"
        :product-groups-and-products="productGroupsAndProducts"
        :product-groups="productGroups"
        :dns-templates="dnsTemplates"
        :accounting-products="accountingProducts"
        :intercompany-accounting-products="intercompanyAccountingProducts"
        :fulfillment-strategies="fulfillmentStrategies"
        :invoice-behaviours="invoiceBehaviours"
        :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
        :termination-rules="terminationRules"
        :product-classes="productClasses"
        :billing-types="billingTypes"
        :requires-domain-options="requiresDomainOptions"
        @form-submitted="submitData"
    />
</template>

<script>
import Form from '~@/Components/Products/ProductAddons/Form'

export default {
    name: 'ProductAddonsCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        productGroupsAndProducts: {
            type: Array,
            default () {
                return []
            }
        },
        productGroups: {
            type: Array,
            default () {
                return []
            }
        },
        dnsTemplates: {
            type: Array,
            default () {
                return []
            }
        },
        accountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        intercompanyAccountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        fulfillmentStrategies: {
            type: Array,
            default () {
                return []
            }
        },
        invoiceBehaviours: {
            type: Array,
            default () {
                return []
            }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: false
        },
        terminationRules: {
            type: Array,
            default: () => { return [] }
        },
        productClasses: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        requiresDomainOptions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        submitData (form) {
            const newForm = { ...form }
            newForm.selectedDowngrades = newForm.selectedDowngrades.map((val) => val.value)
            newForm.selectedUpgrades = newForm.selectedUpgrades.map((val) => val.value)

            newForm.post(this.$route('products.product-addons.store'))
        }
    }
}
</script>
